import React from 'react';
import Icon from '../icon';
const names = {
    horizontal: {
        collapsed: 'falChevronRight',
        expanded: 'falChevronLeft'
    },
    vertical: {
        collapsed: 'falChevronDown',
        expanded: 'falChevronUp'
    }
};
const AccordionItemArrow = ({ collapsed, orientation = 'vertical' }) => (React.createElement(Icon, { name: names[orientation][collapsed ? 'collapsed' : 'expanded'], size: "xs" }));
export default React.memo(AccordionItemArrow);
